import geoConstants from '../constants/geo';

const setGeoLocation = (geoObj) => ({
  type: geoConstants.SET_USER_GEO_LOCATION,
  payload: geoObj,
});

const clearGeoLocation = () => ({ type: geoConstants.CLEAR_GEO_LOCATION });

export const geoActions = {
  setGeoLocation,
  clearGeoLocation,
};
